module.exports = __webpack_public_path__ + "static/img/promotion1.2f394e1c.png";